import { type WrappedInsightEarningsAttributes } from "@clipboard-health/contract-worker-app-bff";
import { Image, Text } from "@clipboard-health/ui-components";
import dollarImagePath from "@src/appV2/lib/assets/images/cbh-wrapped/dollar.png";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { InsightContentWrapper } from "../InsightContentWrapper";

interface EarningsContentProps {
  attributes: WrappedInsightEarningsAttributes;
}

export function EarningsContent(props: EarningsContentProps) {
  const { attributes } = props;

  return (
    <InsightContentWrapper>
      <Text
        variant="h1"
        sx={(theme) => ({
          fontSize: "4rem",
          color: theme.palette.text.invertPrimary,
          marginTop: theme.spacing(5),
        })}
      >
        {formatDollarsAsUsd(attributes.totalEarnings)}
      </Text>

      <Text
        variant="h3"
        sx={(theme) => ({
          color: theme.palette.intent?.warning.text,
          paddingBottom: 4,
        })}
      >
        Earned this year!
      </Text>

      <Image src={dollarImagePath} alt="Dollar" sx={{ position: "absolute", bottom: 0, left: 0 }} />
    </InsightContentWrapper>
  );
}
